import { ElementType, PropsWithChildren } from 'react';
import './style.module.scss';

interface IProps extends React.HTMLAttributes<HTMLHeadingElement> {
	tag?: ElementType;
	text: string;
}

export function Copy(props: PropsWithChildren<IProps>) {
	const { className, tag: Tag = 'p', text } = props;

	const shouldAddSpaceAfterSlash = String(text).match(/\/\s*/);

	return (
		<Tag className={`${className}`} {...props}>
			{shouldAddSpaceAfterSlash ? String(text).replace('/', '/ ') : text}
		</Tag>
	);
}
